import {
  Component,
  Input,
  Output,
  EventEmitter,
  QueryList,
} from '@angular/core';
import { BASIC_IMPORTS } from '../../../imports/common-imports';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'app-tab-header',
  standalone: true,
  imports: [BASIC_IMPORTS],
  templateUrl: './tab-header.component.html',
  styleUrl: './tab-header.component.scss',
})
export class TabHeaderComponent {
  @Input() tabs!: QueryList<TabComponent>;
  @Input() activeIndex: number = 0;
  @Input() style: 'bordered' | 'underline' = 'bordered';
  @Output() tabSelected = new EventEmitter<number>();

  selectTab(index: number) {
    this.tabSelected.emit(index);
  }
}
